import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material'
import { COLORS } from '../theme'
import { primaryButtonSx } from '../styles'

interface TeammateDialogProps {
  open: boolean
  onContinue: () => void
}

/**
 * Shown when a teammate has already started onboarding for this org.
 * The user can review/change anything by navigating back.
 */
export default function TeammateDialog({ open, onContinue }: TeammateDialogProps) {
  return (
    <Dialog open={open} maxWidth="sm" aria-labelledby="teammate-dialog-title" aria-describedby="teammate-dialog-desc">
      <DialogTitle id="teammate-dialog-title" sx={{ fontWeight: 700, color: COLORS.primary, pt: 4, px: 4 }}>
        A teammate has already started onboarding
      </DialogTitle>
      <DialogContent sx={{ px: 4 }}>
        <Typography id="teammate-dialog-desc" sx={{ color: COLORS.bodyText }}>
          One of your team members has already started setting up your organisation.
          We'll drop you in where they left off. You can always go back if you need
          to review or make changes.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 4, pb: 3 }}>
        <Button
          variant="contained"
          onClick={onContinue}
          sx={{ ...primaryButtonSx, px: 4, py: 1 }}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}
